import { RectangularTag } from '#app/components/RectangularTag/RectangularTag.js';
import { SparklesEmoji } from '@contra/icons/emojis';
import { styled } from 'styled-components';

const DraftTagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DraftTag = () => (
  <RectangularTag
    Icon={null}
    label="Draft"
    variant="blue"
  />
);

export const MaybeDraftAndSuggestedTags = ({
  canEdit,
  isDraft,
  isProfileMagicSuggestion,
  variant,
}: {
  readonly canEdit: boolean;
  readonly isDraft: boolean;
  readonly isProfileMagicSuggestion: boolean;
  readonly variant: 'Project' | 'Service';
}) => {
  if (canEdit) {
    if (isProfileMagicSuggestion) {
      return (
        <DraftTagContainer>
          <RectangularTag
            ariaLabel={`${variant} Suggestion Tag`}
            Icon={SparklesEmoji}
            label="Suggested"
            variant="magic-gradient"
          />
          <DraftTag />
        </DraftTagContainer>
      );
    }

    if (isDraft) {
      return <DraftTag />;
    }
  }

  return null;
};
